export default __webpack_public_path__ + "f7bc91f7b32fd033e2e8d2d5d163d96a.png";